import { post, get, AHPLUS_API_URL } from "api/ky";

export const validateActivationToken = async (tripUuid: string, activationToken: string) => {
  return await post(`${AHPLUS_API_URL}/api/v2/trips/${tripUuid}/validate_activation_token`, {
    token: activationToken,
  });
};

export const activate = async (tripUuid: string, activationToken: string) => {
  return await post(`${AHPLUS_API_URL}/api/v2/trips/${tripUuid}/activate`, {
    token: activationToken,
  });
};

export const fetchTrip = async (uuid: string) => {
  return await get(`${AHPLUS_API_URL}/api/v2/trips/${uuid}`);
};

export interface IValidateActivationTokenResponse {
  activationStatus: "active" | "inactive";
  email: string;
  resetPasswordToken: string;
}

export interface ICompleteTrip {
  tripUuid: string;
  checkoutId: string;
  channel: string;
}
